import { Vector3 } from "three"

export const CAM_POSITION_INDEX = {
  start: {
    position: new Vector3(-0.5, 1.1, -1),
    target: new Vector3(0.5, 0.2, 0),
  },

  wide: {
    position: new Vector3(-0.5, 1.1, -1),
    target: new Vector3(0.5, 0.2, 0),
  },

  corner: {
    position: new Vector3(-0, 0.93, -0.1),
    target: new Vector3(0.9, 0.2, 0),
  },
  phase2: {
    position: new Vector3(-0.25, 1.1, -1),
    target: new Vector3(0, 0.2, 0),
  },
}
